import React from 'react';
import { motion } from 'framer-motion';
import { eventCatering } from '@/data/content';
import Button from '@/components/ui/Button';

const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] as const },
};

const EventCateringBlock: React.FC = () => (
    <motion.section {...fadeInUp} className="py-20 md:py-32 bg-white dark:bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-gradient-to-br from-white via-orange-50/50 to-orange-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-800/90 rounded-[3rem] p-10 md:p-16 shadow-2xl shadow-orange-900/5 dark:shadow-none border border-orange-100/50 dark:border-gray-700 relative overflow-hidden group">
                <div className="absolute top-0 right-0 w-96 h-96 bg-app-primary/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none group-hover:bg-app-primary/20 transition-colors duration-700 animate-pulse-slow"></div>
                <div className="absolute bottom-0 left-0 w-80 h-80 bg-app-primary/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/3 pointer-events-none animate-float"></div>

                <div className="relative z-10 flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
                    <div className="flex-1 text-center lg:text-left">
                        <span className="inline-block px-4 py-1.5 rounded-full bg-app-primary/10 text-app-primary font-black text-sm tracking-wide uppercase mb-6 shadow-sm">
                            {eventCatering.badge}
                        </span>
                        <h3 className="text-4xl md:text-5xl font-black text-gray-900 dark:text-white mb-6 leading-tight">
                            {eventCatering.heading}
                        </h3>
                        <p className="text-xl text-gray-600 dark:text-gray-300 leading-relaxed max-w-2xl mx-auto lg:mx-0 font-medium">
                            {eventCatering.description}
                        </p>
                    </div>
                    <div className="w-full lg:w-auto">
                        <div className="flex flex-col sm:flex-row lg:flex-col gap-5 items-stretch justify-center min-w-[240px]">
                            <Button to="/contact" size="lg" className="w-full text-center">
                                {eventCatering.cta_quote}
                            </Button>
                            <Button to="/menu" size="lg" variant="secondary" className="w-full text-center">
                                {eventCatering.cta_order}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </motion.section>
);

export default EventCateringBlock;
